export default [
    { key: 0, value: "Numeric" },
    { key: 1, value: "Text" },
    { key: 2, value: "Combo" },
]